import { X, Warning } from "@phosphor-icons/react";

export function ConfirmDialog({ open, title, message, confirmLabel = "Delete", cancelLabel = "Cancel", danger = true, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onCancel} data-testid="confirm-dialog">
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <div className="flex items-start justify-between p-6 border-b border-[color:var(--border)]">
          <div className="flex items-start gap-3">
            <div className={`w-10 h-10 rounded-md flex items-center justify-center ${danger ? "bg-red-500/10 border border-red-500/30" : "bg-[color:var(--surface-2)] border border-[color:var(--border)]"}`}>
              <Warning size={20} weight="bold" className={danger ? "text-red-400" : "text-[#007AFF]"} />
            </div>
            <div>
              <h3 className="font-heading text-lg font-bold tracking-tight">{title}</h3>
              <p className="text-sm text-[color:var(--text-secondary)] mt-1">{message}</p>
            </div>
          </div>
          <button onClick={onCancel} className="text-[color:var(--text-secondary)] hover:text-white" data-testid="confirm-dialog-close"><X size={18} /></button>
        </div>
        <div className="p-6 flex gap-3 justify-end">
          <button onClick={onCancel} className="btn-ghost" data-testid="confirm-dialog-cancel">{cancelLabel}</button>
          <button
            onClick={onConfirm}
            data-testid="confirm-dialog-confirm"
            className={danger ? "btn-danger" : "btn-primary"}
            style={danger ? { padding: "9px 16px", fontSize: 13 } : undefined}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
